import Axios from 'axios';
import { SERVER_URL, FRONT_END_URL } from './Constants';
import { getQueryInfoFromUrl } from './CommonUtils';

// Shared Ryft payment-session helpers, used by both the inline web form (RyftForm) and the native-app
// browser checkout (RyftHostedCheckout) so the request body / amount logic stays in one place.

// Current order total (gift-card-adjusted total when present), formatted to 2dp like the server expects.
export const getRyftAmount = (shoppingCart, giftCards) => {
    const totalWithGiftCard = giftCards && giftCards.giftCards ? giftCards.giftCards.total : null;
    return totalWithGiftCard ? totalWithGiftCard.toFixed(2) : shoppingCart.total;
};

// Shared request body for createPaymentSession (init) and /payment/authorize (update).
export const buildRyftPaymentRequest = ({ customer, selectedRestaurant, shoppingCart, giftCards }) => {
    const { brandId, navigationType } = getQueryInfoFromUrl();
    const redirectUrl = brandId
        ? `${FRONT_END_URL}/?brandId=${brandId}&navigationType=${navigationType}&restaurantId=${selectedRestaurant.restaurantId}&customerId=${customer.id}#/checkout`
        : `${FRONT_END_URL}/?restaurantId=${selectedRestaurant.restaurantId}&customerId=${customer.id}#/checkout`;

    return {
        customerId: customer.id,
        restaurantId: selectedRestaurant.restaurantId,
        amount: getRyftAmount(shoppingCart, giftCards),
        amountWithoutServiceFee: shoppingCart.subtotal,
        serviceFee: shoppingCart.serviceFee,
        currency: selectedRestaurant.currency,
        ryftAuthorizeRequest: {
            redirectUrl: redirectUrl
        }
    };
};

// Normalise an Axios error from a Ryft backend call into the shape the sending-order modal expects:
//   - userMessage: the friendly, customer-facing reason from the backend DTO (when present)
//   - message:     the generic Axios message ("Request failed with status code 500") used as the
//                  fallback. We deliberately DO NOT fall back to the DTO's `message`, which is the
//                  raw Java stack trace and must never be shown to the customer.
// The reducer (providerID 10) prefers userMessage and falls back to message.
export const buildRyftError = (error) => ({
    userMessage: error && error.response && error.response.data ? error.response.data.userMessage : undefined,
    message: error ? error.message : undefined,
});

// Create the Ryft payment session. Returns response.data (which carries ryftAuthorizationDTO +
// storedCards); throws on failure so the caller can surface the error in its own way.
export const createRyftPaymentSession = async (requestBody, customerToken) => {
    const header = { headers: { 'Authorization': `TOKEN${customerToken}` } };
    const response = await Axios.post(`${SERVER_URL}/payment/ryft/create-payment-session`, requestBody, header);
    return response.data;
};